import styled from "styled-components";
import { size } from "styled-theme";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  gap: 40px;

  .review-badges {
    display: flex;
    flex-direction: column;
    justify-content: center;

    iframe {
      min-width: 290px !important;
    }

    @media only screen and (min-width: ${size("M")}) {
      flex-direction: row;
    }
  }

  .congrats-title {
    margin-top: 40px;
  }

  .full-width {
    width: 100%;
  }
`;

export default Wrapper;
